import CardNewsFullWidth from './CardNewsFullWidth';

export default CardNewsFullWidth;
